import { FunctionComponent } from "react"
import NotificationTypes from "src/utilities/Notifications/Types/NotificationTypes"
import "./PSDecoupler.css"

interface PSDecouplerProps {
    notification: NotificationTypes
}

const PSDecoupler: FunctionComponent<PSDecouplerProps> = (props) => {
    return (
        <div className="PSDecoupler">
            <span className="material-icons">account_tree</span>
            <p>{props.notification.text}</p>
        </div>
    )
}

export default PSDecoupler